import Index from './Components/Index.vue';
import DefaultLayout from '../../Components/Layout/DefaultLayout.vue';

import resource from '../../Util/resources';

const routes = [{
    path: '/Settings/IOFormat/',
    alias: '/Settings/IOFormat/Index',
    component: DefaultLayout,
    meta: {
        title: resource('IOFormat_Index_Title'),
        breadcrumb: resource('Breadcrumb_IOFormatManager')
    }, 
    children: [
        {
            name: 'ioformat-index',
            path: '',
            component: Index,
            meta: {
                title: resource('IOFormat_Index_Title'),
                header: resource('IOFormat_Index_Heading'),
                breadcrumb: resource('Breadcrumb_IOFormatDetails')
            }, 
        }
    ]
}];

export {
    routes
};